'use client';

import { maybeReloadForChunkError } from '@/components/ChunkReloadGuard';
import { captureError } from '@/utils/capture-error';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // A chunk failure is being retried by reload — reporting it would be noise.
    if (maybeReloadForChunkError(error)) return;
    // React render errors don't hit window.onerror, so report them explicitly.
    // force: a render crash must always report, even past the session cap.
    captureError(error, { operation: 'react.render-error', digest: error.digest }, { force: true });
    // Log the error when the component mounts, but don't show any UI
    console.error(error, {
      component: 'GlobalError',
      digest: error.digest,
      url: typeof window !== 'undefined' ? window.location.href : '',
      timestamp: new Date().toISOString(),
    });
  }, [error]);

  // Return a completely transparent error div instead of html/body structure
  return (
    <div 
      style={{ 
        background: 'transparent', 
        pointerEvents: 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999
      }}
    >
      {/* No content rendered for complete transparency */}
    </div>
  );
} 